import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import type { Personel } from '../types'

/** Personel adının yanında firma ortağı ve emekli (prim yok) etiketleri. */
export function PartnerTags({ personel }: { personel: Pick<Personel, 'ortak' | 'emekli'> }) {
  const { t } = useTranslation()
  if (!personel.ortak && !personel.emekli) return null
  return (
    <span className="inline-flex shrink-0 items-center gap-1">
      {personel.ortak ? <Badge tone="info">{t('hr.personel.tags.ortak')}</Badge> : null}
      {personel.emekli ? <Badge tone="neutral">{t('hr.personel.tags.emekli')}</Badge> : null}
    </span>
  )
}
